module.exports = __webpack_public_path__ + "static/favicon-2c5cc696eb5af9e57da429e2a3f249eb.ico";